import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Panel, Well, Button, Label, ButtonToolbar } from 'react-bootstrap';
import GTRAlert from '../components/GTRAlert';
import Loader from '../components/Loader';
import api from '../helpers/apiClient';
import _ from 'lodash'
import * as errorActionCreators from '../redux/actions/error';
import config from '../config'
import qs from 'qs';

const currency = window.location.hostname === 'seller.giftr.my' ? 'RM' : 'S$'

class Invoice extends Component {
  constructor(props) {
    super(props);

    const { id } = qs.parse(location.search.substr(1));

    this.state = {
      links: null,
      loading: false,
      id
    };
  }

  componentDidMount() {
    this.fetchInvoice()
  }

  fetchInvoice = () => {

    const { id } = this.state;

    this.setState({ loading: true });

    return api(`/invoice?id=${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((result) => {
      this.setState({ loading: false });

      if(result){
        this.setState({ links: result });
      }
    }).catch(err => {
      this.setState({ loading: false });
      if (err) {
        window.scrollTo(0, 0);
        if (err.validationError) {
          this.setState({ error: err.validationError });
        }
        else if (err.message) {
          this.setState({ error: err.message });
        }
        else {
          this.setState({ error: err });
        }
      }
    });
  }

  render() {
    const {  error, user, match } = this.props;
    const { links, loading } = this.state;
    const { id } = qs.parse(location.search.substr(1));

    return (
      <div className="container">
        {
          loading &&
          <Loader />
        }
        {
          error &&
          <GTRAlert bsStyle="danger" alert={error} />
        }
        <h1>Invoice: {id}</h1>
        {
          !loading && links &&
          <div>
              {
                links.map((link, i) => {
                  return (
                    <div key={i}>
                      <div>
                        <span>{link.vendor} - <a target="_blank" href={link.fileLink}>Download invoice</a></span>
                      </div>
                    </div>
                  )
                })
              }
          </div>
        }
      </div>
    );
  }
}

export default connect((state, props) => {
  return {
    error: state.error,
    user: state.auth.user
  };
}, {
  ...errorActionCreators
})(Invoice);
